import React from 'react';

interface ApprovalBadgeProps {
  count: number;
}

const ApprovalBadge: React.FC<ApprovalBadgeProps> = ({ count }) => {
  if (count <= 0) return null;

  return (
    <span className="inline-flex items-center rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800 dark:bg-amber-900/30 dark:text-amber-200">
      {count} approval{count !== 1 ? 's' : ''} waiting
    </span>
  );
};

export default ApprovalBadge;
